import { takeLatest, put, call, select } from 'redux-saga/effects';
import { UPDATE_GIFT_SAGA } from "../sagaTypes";
import { loaderAction, giftFormAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { getGiftsSagaAction } from "../sagaActions";
import { GIFT_FORM_INITIAL } from "../initialStateConstant";

const request = data => {
    return fetch(`${ url }/update_gift`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerUpdateGift(args) {
    const user = yield select(state => state.user);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('id', args.data.id || '');
        formData.append('name', args.data.name);
        formData.append('cost', args.data.cost);
        formData.append('description', args.data.description);
        formData.append('establishments', args.data.establishments);
        formData.append('price_id', args.data.price_id);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Обновляем список бонусов
            yield put(getGiftsSagaAction());
            // Очищаем форму бонуса
            yield put(giftFormAction(GIFT_FORM_INITIAL));
            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherUpdateGift() {
    yield takeLatest(UPDATE_GIFT_SAGA, workerUpdateGift);
}